export const contractDetailsById = {
    ['contractId1']: {
        id: 'contractId1',
        name: 'testContract1',
        contract: 'testContract1',
        status: 'published',
        unique_identifier_type: {
            id: 'uniqueIdentifierTypeId2',
            name: 'NINO',
            status: 'published'
        },
        contract_type: {
            id: 'contractTypeId1',
            name: 'EMPLOYABILITY',
            status: 'published'
        }
    },
    ['contractId2']: {
        id: 'contractId2',
        name: 'testContract2',
        contract: 'testContract2',
        status: 'published',
        unique_identifier_type: {
            id: 'uniqueIdentifierTypeId2',
            name: 'NINO',
            status: 'published'
        },
        contract_type: {
            id: 'contractTypeId2',
            name: 'WELLBEING',
            status: 'published'
        }
    },
    ['contractId3']: {
        id: 'contractId3',
        name: 'testContract3',
        contract: 'testContract3',
        status: 'published',
        unique_identifier_type: {
            id: 'uniqueIdentifierTypeId1',
            name: 'NHS_NUMBER',
            status: 'published'
        },
        contract_type: {
            id: 'contractTypeId2',
            name: 'WELLBEING',
            status: 'published'
        }
    }
};
